import { Skeleton } from "@/atoms"
import { useAgentById } from "@/organisms/Drawers/applications/ai-discovery/useAiDiscovery"
import { AiPolicyProvider } from "@/pages/GovernancePage/components/organisms/AiPolicyProvider"
import { Tab } from "./Tab"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const AiPolicyTabAgentAiDiscoveryDrawer = (
  props: TabComponentProps & {
    record?: { meta?: { policyId?: string } }
  }
) => {
  const { data, isLoading } = useAgentById(props)

  return (
    <AiPolicyProvider
      agentName={data?.name}
      mode="view"
      id={props.record?.meta?.policyId}
    >
      {(isLoading || !data) && <Skeleton />}
      {!isLoading && !!data && <Tab {...props} agent={data} />}
    </AiPolicyProvider>
  )
}
